module.exports = __webpack_public_path__ + "img/home-bg-img.c6e72ea6.png";